import { render, staticRenderFns } from "./TeachersByAlternatives.vue?vue&type=template&id=063eadfb&"
import script from "./TeachersByAlternatives.vue?vue&type=script&lang=js&"
export * from "./TeachersByAlternatives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports